<div
  class="notification-item"
  [class.unread]="!notification.isRead"
  [class.compact]="compact"
  (click)="onClick()"
>
  <!-- Notification content -->
  <div class="notification-content">
    <div class="notification-header">
      <h4 class="notification-title">{{ title }}</h4>
      <span class="notification-time">{{ getTimeAgo() }}</span>
    </div>
    <p class="notification-body">{{ body }}</p>
  </div>
</div>
